import { render, staticRenderFns } from "./participateinDiscountActivity.vue?vue&type=template&id=f53efd52&scoped=true"
import script from "./participateinDiscountActivity.vue?vue&type=script&lang=js"
export * from "./participateinDiscountActivity.vue?vue&type=script&lang=js"
import style0 from "./participateinDiscountActivity.vue?vue&type=style&index=0&id=f53efd52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53efd52",
  null
  
)

export default component.exports